export default __webpack_public_path__ + "static/media/checkedTrue.673f8b0d.svg";